<template>
  <div>
    <div class="totalPie">
      <div class="tit">
        <p>基本信息（{{ydbName}}）</p>
        <i class="el-icon-close" style="float: right; color:#fff; font-size: 20px; cursor: pointer;line-height: 30px" @click="close"></i>
      </div>
      <div class="address">
        <div>
          <p></p>
          <span>{{position}}</span>
        </div>
      </div>
      <!-- <div class="address">
        <div>
          <p class="sn"></p>
          <span>枢纽组成：</span>
        </div>
        <div>
          <p>{{snzc}}</p>
        </div>
      </div>
      <div class="address">
        <div>
          <p class="sn"></p>
          <span>所在支流：</span>
        </div>
        <div>
          <p>{{ydbSszl}}</p>
        </div>
      </div>
      <div class="address">
        <div>
          <p class="sn"></p>
          <span>所在小流域：</span>
        </div>
        <div>
          <p>{{ydbSzxly}}</p>
        </div>
      </div>
      <div class="address">
        <div>
          <p class="xly"></p>
          <span>所属串联坝：</span>
        </div>
        <div>
          <p>{{ydbClbName}}</p>
        </div>
      </div>
      <div class="address">
        <div>
          <p class="kzmj"></p>
          <span>控制面积：</span>
        </div>
        <div>
          <p>{{kongzhimianji}}k㎡</p>
        </div>
      </div>
      <div class='dabdetails'>
        <div>
          <p class="bagao"></p>
          <span>坝高：</span>
          <p>{{bagao}}m</p>
        </div>
        <div>
          <p class="bagao"></p>
          <span>坝顶长：</span>
          <p>{{badingchang}}m</p>
        </div>
      </div>
      <div class='dabdetails'>
        <div>
          <p class="bagao"></p>
          <span>总库容：</span>
          <p>{{ydbZkr}}万m³</p>
        </div>
        <div>
          <p class="bagao"></p>
          <span>滞洪库容：</span>
          <p>{{ydbDhkr}}万m³</p>
        </div>
      </div>
      <div class='dabdetails'>
        <div>
          <p class="bagao"></p>
          <span>设计淤积库容：</span>
          <p>{{ydbSjyjkr}}万m³</p>
        </div>
        <div>
          <p class="bagao"></p>
          <span>已淤库容：</span>
          <p>{{ydbYykr}}万m³</p>
        </div>
      </div>
      <div class='dabdetails'>
        <div>
          <p class="bagao"></p>
          <span>设计淤积面积：</span>
          <p>{{ydbSjyjmj}}hm²</p>
        </div>
        <div>
          <p class="badingchang"></p>
          <span>已淤积面积：</span>
          <p>{{ydbYyjmj}}hm²</p>
        </div>
      </div>
      <div class='dabdetails'>
        <div>
          <p class="bagao"></p>
          <span>淤地坝图片：</span>
          <p>未上传</p>
        </div>
        <div>
          <p class="badingchang"></p>
          <span>淤地坝文档：</span>
          <p>未上传</p>
        </div>
      </div> -->
      <div style="width: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  justify-content: space-around;padding:0px 10px">

<div style="height: 100%;flex:1">
          <div class="contents1">
            <p>枢纽组成:<span>{{ snzc}}</span></p>
            <p>所在支流:<span>{{ ydbSszl }}</span></p>
            <p>所在小流域:<span>{{ydbSzxly}}</span></p>
            <p>所属串联坝:<span>{{ ydbClbName}}</span></p>
            <p>控制面积:<span>{{kongzhimianji}}k㎡</span></p>
          </div>
        </div>
        <div style="flex:1" v-if="ydbName=='张塔山沟'">
            <img style="height: 120px;width: 160px;" src="../../common/images/qrcode.png"/>
        </div>
      </div>
      <div style="width: 100%;height: 50%;">
      <div class='dabdetails'>
        <div>
          <p class="bagao"></p>
          <span>总库容：</span>
          <p>{{ydbZkr}}万m³</p>
        </div>
        <div>
          <p class="bagao"></p>
          <span>滞洪库容：</span>
          <p>{{ydbDhkr}}万m³</p>
        </div>
      </div>
      <div class='dabdetails'>
        <div>
          <p class="bagao"></p>
          <span>设计淤积库容：</span>
          <p>{{ydbSjyjkr}}万m³</p>
        </div>
        <div>
          <p class="bagao"></p>
          <span>已淤库容：</span>
          <p>{{ydbYykr}}万m³</p>
        </div>
      </div>
      <div class='dabdetails'>
        <div>
          <p class="bagao"></p>
          <span>设计淤积面积：</span>
          <p>{{ydbSjyjmj}}hm²</p>
        </div>
        <div>
          <p class="badingchang"></p>
          <span>已淤积面积：</span>
          <p>{{ydbYyjmj}}hm²</p>
        </div>
      </div>
      <div class='dabdetails'>
        <div>
          <p class="bagao"></p>
          <span>淤地坝图片：</span>
          <p>未上传</p>
        </div>
        <div>
          <p class="badingchang"></p>
          <span>淤地坝文档：</span>
          <p>未上传</p>
        </div>
      </div>
       </div>
      </div>



  </div>
</template>

<script>
  import {
    ydbjbxxsearch
  } from "@/api/api.js";
  export default {
    props: ["gisclick"],
    data() {
      return {
        ydbName: "xxxxxx坝",
        ydbbx: '',
        ydbType: null,
        position: "",
        jcny: '',
        snzc: '',
        bagao: 0,
        badingchang: 0,
        kongzhimianji: 0,
        gaijian: '',
        laojiuba: '',
        cxrq: '',
        zrzt: '',
        tsgz: '',
        jkss: '',
        yxrs: 0,
        zyss: '',
        bxqk: '',
        ydbSszl:'',
        ydbClbName:'',
        ydbZkr:'',
        ydbDhkr:'',
        ydbSjyjmj:'',
        ydbSjyjkr:'',
        ydbYykr:'',
        showInfo:true
      };
    },
    mounted() {
      if (this.$store.state.gisQueryData != null) {
        let data = this.$store.state.gisQueryData;
        this.ydbName = data.ydbName;
        this.ydbbx = data.ydbSfwggb;
        this.ydbType = data.ydbBaXing;
        this.position = data.ydbSheng + data.ydbShi + data.ydbXian + data.ydbXiang + data.ydbCun;
        this.jcny = data.ydbJcnd;
        this.snzc = data.ydbSnzc;
        this.bagao = data.ydbBaGao.toFixed(2);
        this.badingchang = data.ydbBdcd.toFixed(2);
        this.kongzhimianji = data.ydbKzmj.toFixed(2);
        this.gaijian = data.ydbSfgj;
        this.laojiuba = data.ydbSfljb;
        this.cxrq = data.ydbSfcxjg;
        this.zrzt = data.ydbGlzrzt;
        this.tsgz = data.ydbSfxygzsj;
        this.jkss = data.ydbJkss;
        this.yxrs = data.ydbYxrs;
        this.zyss = data.ydbZyss;
        this.bxqk = data.bxqk;
        this.ydbFxjb = data.ydbFxjb;//风险级别
        this.ydbSfwclb = data.ydbSfwclb?'是' : '否';//ydbSfwclb 是否为串联坝，1表示是，其他为否
        this.ydbSzxly = data.ydbSzxly;//所在小流域
        this.ydbSszl = data.ydbSszl;//所在支流
        this.ydbClbName = data.ydbClbName;//所属串联坝名称
        this.ydbZkr = data.ydbZkr;//总库容
        this.ydbDhkr = data.ydbDhkr;//滞洪库容
        this.ydbSjyjmj = data.ydbSjyjmj;//设计淤积面积
        this.ydbYyjmj = data.ydbYyjmj;//已淤积面积
        this.ydbSjyjkr = data.ydbSjyjkr;
        this.ydbYykr = data.ydbYykr;
      }
    },
    watch: {
      gisclick(a) {
        if (a.ydbCode || a.damCode) {
          this.$store.state.gisQueryData = a;
          let params = {
            ydbCode: a.ydbCode ? a.ydbCode: a.damCode
          };
          this.ydbListFun(params);
        }
      },
    },
    methods: {
      ydbListFun(params) {
        let _this = this;
        ydbjbxxsearch(params).then((res) => {
          console.log("gis点位点击后数据->",res)
          _this.ydbName = res.data.ydbName;
          _this.ydbbx = res.data.ydbSfwggb;
          _this.ydbType = res.data.ydbBaXing;
          _this.position = res.data.ydbSheng + res.data.ydbShi + res.data.ydbXian + res.data.ydbXiang + res.data.ydbCun;
          _this.jcny = res.data.ydbJcnd;
          _this.snzc = res.data.ydbSnzc;
          _this.bagao = res.data.ydbBaGao.toFixed(2);
          _this.badingchang = res.data.ydbBdcd.toFixed(2);
          _this.kongzhimianji = res.data.ydbKzmj.toFixed(2);
          _this.gaijian = res.data.ydbSfgj;
          _this.laojiuba = res.data.ydbSfljb;
          _this.cxrq = res.data.ydbSfcxjg;
          _this.zrzt = res.data.ydbGlzrzt;
          _this.tsgz = res.data.ydbSfxygzsj;
          _this.jkss = res.data.ydbJkss;
          _this.yxrs = res.data.ydbYxrs;
          _this.zyss = res.data.ydbZyss;
          _this.bxqk = res.data.bxqk;
          _this.ydbFxjb = res.data.ydbFxjb;//风险级别
          _this.ydbSfwclb = res.data.ydbSfwclb?'是' : '否';//ydbSfwclb 是否为串联坝，1表示是，其他为否
          _this.ydbSzxly = res.data.ydbSzxly;//所在小流域
          _this.ydbSszl= res.data.ydbSszl;//所在支流
          _this.ydbClbName = res.data.ydbClbName;//所属串联坝名称
          _this.ydbZkr = res.data.ydbZkr;//总库容
          _this.ydbDhkr = res.data.ydbDhkr;//滞洪库容
          _this.ydbSjyjmj = res.data.ydbSjyjmj;//设计淤积面积
          _this.ydbYyjmj = res.data.ydbYyjmj;//已淤积面积
          _this.ydbSjyjkr = res.data.ydbSjyjkr;
          _this.ydbYykr = res.data.ydbYykr;
        });
      },
      close(){
        this.$emit('closeInfo')
      }
    },
  };
</script>

<style scoped>
  .totalPie {
    width: 100%;
    height: 350px;
    background: url(../../common/images/contentborder.png) no-repeat center;
    background-size: 102% 100%;
    overflow: hidden;
  }

  .jcxxname {
    width: 90%;
    height: 50px;
    margin: 0 auto;
    border-bottom: 1px dotted #ccc;
  }

  .jcxxname p {
    float: left;
    width: 20px;
    height: 20px;
    background: url(../../common/images/jcnamecion.png) no-repeat center;
    background-size: 100% 100%;
    margin-top: 14px;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
  }

  .jcxxname h6 {
    font-size: 16px;
    color: #fff;
    line-height: 20px;
    float: left;
    margin-left: 8px;
    margin-top: 14px;
  }

  .jcxxname span {
    float: left;
    display: block;
    height: 20px;
    width: 60px;
    border: 1px solid #00b3fe;
    border-radius: 10px;
    font-size: 14px;
    text-align: center;
    line-height: 20px;
    color: #00b3fe;
    margin-left: 10px;
    margin-top: 14px;
  }

  .address {
    width: 100%;
    min-height: 24px;
    line-height: 24px;
    margin: 0 auto;
    float: left;
  }
  .address11 {
    width: 50%;
    min-height: 24px;
    line-height: 24px;
    margin: 0 auto;
    float: left;
  }

  .boderBottom {
    border-bottom: 1px dotted #ccc;
  }

  .address div:nth-child(1) {
    float: left;
  }

  .address div:nth-child(1) p {
    width: 15px;
    height: 15px;
    float: left;
    background-size: 100% 100%;
    margin-right: 6px;
    margin-top: 7px;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
  }

  .address div:nth-child(1) span {
    float: left;
    text-align: center;
    font-size: 14px;
    color: #00b3fe;
    margin-top: 5px;
  }

  .address div:nth-child(2) {
    /* width: calc(100% - 90px); */
    /* width: -webkit-calc(100% - 75px); */
    /* width: -moz-calc(100% - 75px); */
    max-width: 73%;
    float: left;
  }

  .address div:nth-child(2) p {
    line-height: 20px;
    color: #fff;
    font-size: 14px;
    margin-top: 5px;
    line-height: 24px;
    /* overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap; */
  }

  .dabdetails {
    width: 100%;
    min-height: 24px;
    padding-top: 10px;
    margin: 0 auto;
  }

  .dabdetails div:nth-child(1) {
    width: 50%;
    float: left;
    /* margin-left: 5px; */
  }
  .dabdetails div:nth-child(2) {
    width: 50%;
    float: left;
    /* margin-left: 5px; */
  }

  .dabdetails p{
    font-size: 14px;
    color: #fff;
    /* font-weight: 600; */
    line-height: 20px;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
  }

  .dabdetails div span {
    line-height: 24px;
    color: #00b3fe;
    font-size: 14px;
    float: left;
    margin-right: 6px;
  }

/*  .dabdetails div:nth-child(1) {
    border-right: 1px solid #717c8c;
  } */

  .bagao {
    width: 15px;
    height: 15px;
    float: left;
    margin-right: 6px;
    margin-top: 3px;
    background-size: 100% 100% !important;
  }

  .badingchang {
    width: 15px;
    height: 15px;
    float: left;
    margin-right: 6px;
    margin-top: 3px;
    background-size: 100% 100% !important;
  }

  .gaijian {
    width: 15px;
    height: 15px;
    float: left;
    margin-right: 6px;
    margin-top: 3px;
    background: url(../../common/images/gj.png) no-repeat center !important;
    background-size: 100% 100% !important;
  }

  .laojiuba {
    width: 15px;
    height: 15px;
    float: left;
    margin-right: 6px;
    margin-top: 3px;
    background: url(../../common/images/ljb.png) no-repeat center !important;
    background-size: 100% 100% !important;
  }

  .cxrq {
    width: 15px;
    height: 15px;
    float: left;
    margin-right: 6px;
    margin-top: 3px;
    background: url(../../common/images/cxrq.png) no-repeat center !important;
    background-size: 100% 100% !important;
  }

  .zrzt {
    width: 15px;
    height: 15px;
    float: left;
    margin-right: 6px;
    margin-top: 3px;
    background: url(../../common/images/zrzt.png) no-repeat center !important;
    background-size: 100% 100% !important;
  }

  .tsgz {
    width: 15px;
    height: 15px;
    float: left;
    margin-right: 6px;
    margin-top: 3px;
    background: url(../../common/images/tsgz.png) no-repeat center !important;
    background-size: 100% 100% !important;
  }

  .jkss {
    background: url(../../common/images/jkss.png) no-repeat center !important;
    background-size: 100% 100% !important;
  }

  .aqfx {
    background: url(../../common/images/aqfx.png) no-repeat center !important;
    background-size: 100% 100% !important;
  }

  .yxrs {
    width: 15px;
    height: 15px;
    float: left;
    margin-right: 6px;
    margin-top: 3px;
    background: url(../../common/images/yxrs.png) no-repeat center !important;
    background-size: 100% 100% !important;
  }

  .zyss {
    width: 15px;
    height: 15px;
    float: left;
    margin-right: 6px;
    margin-top: 3px;
    background: url(../../common/images/zyss.png) no-repeat center !important;
    background-size: 100% 100% !important;
  }

  .bxqk {
    background: url(../../common/images/bxqk.png) no-repeat center !important;
    background-size: 100% 100% !important;
  }
  .contents1 {
  width: 90%;
  margin: 0 10px;
  height: 80px;
}

.contents1 p {
  float: left;
  width: 100%;
  margin: 0;
  /* text-align: center; */
  font-size: 14px;
  line-height: 24px;
  color: #00B3FE;
}

.contents1 p span {
  color: #DEE0E2;
  font-weight: 600;
  padding-left: 5px;
}
</style>
